import { useRecoilValue } from 'recoil'

import CardWithTabs from '../../../components/CardWithTabs'
import LineChart from '../../../components/LineChart'
import useLocationDateTimeForm from '../../../hooks/useLocationDateTimeForm'
import { ServiceAtom } from '../../../recoil/atoms'
import { roundDecimal } from '../../../utils/display'
import useGetPushNotificationCountSent from '../hooks/useGetPushNotificationCountSent'
import useGetPushNotificationCountViewed from '../hooks/useGetPushNotificationCountViewed'
import useGetPushNotificationCTR from '../hooks/useGetPushNotificationCTR'

function NotificationPerformance({ className }: { className?: string }) {
  const { form } = useLocationDateTimeForm()
  const service = useRecoilValue(ServiceAtom)

  const { pushNotificationCount, pushNotificationCountLoading } = useGetPushNotificationCountSent({
    serviceId: service.value,
    siteId: form.siteId,
    floorId: form.floorId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })
  const { pushNotificationCountViewed, pushNotificationCountViewedLoading } = useGetPushNotificationCountViewed({
    serviceId: service.value,
    siteId: form.siteId,
    floorId: form.floorId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })
  const { pushNotificationCTR, pushNotificationCTRLoading } = useGetPushNotificationCTR({
    serviceId: service.value,
    siteId: form.siteId,
    floorId: form.floorId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })

  return (
    <CardWithTabs
      className={className}
      title='店内通知分析'
      tabs={[
        {
          title: '配信数',
          value: 'notification',
          latest: pushNotificationCount?.currentPeriodValue ?? 0,
          qty: '回',
          isLoading: pushNotificationCountLoading,
          children: (
            <LineChart
              groupLabel='配信数'
              labels={pushNotificationCount?.pushNotificationAnalyticsDatas?.map((e) => e.date) ?? []}
              datas={pushNotificationCount?.pushNotificationAnalyticsDatas?.map((e) => e.value) ?? []}
              xAxisLabel=''
              yAxisLabel='(回)'
            />
          ),
        },
        {
          title: '開封数',
          value: 'open',
          latest: pushNotificationCountViewed?.currentPeriodValue ?? 0,
          qty: '回',
          isLoading: pushNotificationCountViewedLoading,
          children: (
            <LineChart
              groupLabel='開封数'
              labels={pushNotificationCountViewed?.pushNotificationCountViewedDatas?.map((e) => e.date) ?? []}
              datas={pushNotificationCountViewed?.pushNotificationCountViewedDatas?.map((e) => e.value) ?? []}
              xAxisLabel=''
              yAxisLabel='(回)'
            />
          ),
        },
        {
          title: '開封率',
          value: 'open-rate',
          latest: roundDecimal(((pushNotificationCTR?.currentPeriodValue ?? 0) * 100), 2),
          qty: '%',
          isLoading: pushNotificationCTRLoading,
          children: (
            <LineChart
              groupLabel='開封率'
              labels={pushNotificationCTR?.pushNotificationCTRDatas?.map((e) => e.date) ?? []}
              datas={
                pushNotificationCTR?.pushNotificationCTRDatas?.map((e) => {
                  const value = roundDecimal((e.value * 100), 2)
                  return value > 1 ? value : roundDecimal(value, 2)
                  // e.value > 1 ? e.value : roundDecimal(e.value, 2),
              }) ?? []
              }
              xAxisLabel=''
              yAxisLabel='(%)'
            />
          ),
        },
      ]}
    />
  )
}

NotificationPerformance.defaultProps = {
  className: '',
}

export default NotificationPerformance
